<template>
  <div>
    <h3>{{ $t(heading) }}</h3>
    <ol>
      <li v-for="({ link, title, hint }, index) in items" :key="link + index">
        <a
            class="btn-link"
            :href="link"
            :title="hintText(hint)"
        >{{ $t(title.path, title.args) }}</a>
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'ReLinkingItemList',
  props: {
    heading: { type: String, required: true },
    items: { type: Array, required: true },
  },
  methods: {
    hintText (hint) {
      if (!hint) {
        return false;
      }
      const { path, args } = hint;

      return this.$t(path, args);
    },
  },
};
</script>

<style scoped lang="scss">
h3 {
  font-weight: 500;
  text-align: center;
  padding-bottom: rem(24);
}
ol > li {
  text-align: center;
  margin: 0 rem(16);
  padding: rem(12) 0;
  border-top: solid 1px rgba(0, 0, 0, 0.15);
}
ol > li:last-child {
  border-bottom: solid 1px rgba(0, 0, 0, 0.15);
}
ol > li > a {
  font-weight: 500;
}
</style>
